<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="subtitle" />
    <!-- Main Content-->
    <main>
        <div class="container px-4">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8 col-xl-8">
                    <div class="gallery-container">
                        <el-row v-if="relation_list">
                            <el-col :span="24" v-for="value, index in relation_list" style="padding-bottom: 2rem;">
                                <el-row>
                                    <el-col :span="24">
                                        <el-card :key="value" shadow="hover" style="text-align: center;"
                                            @click="toDetail(value.title)">
                                            <el-row :gutter="10">
                                                <el-col :span="24">
                                                    <h4 style="float: left;font-size:1.25rem;">
                                                        {{ value.title }}
                                                    </h4>
                                                    <el-divider />
                                                </el-col>
                                                <el-col :span="24">
                                                    <el-row :gutter="5">
                                                        <template v-for="item, index in ga.filter(item => item.includes(value.name1) && item.includes(value.name2) && item.includes(value.name3) && item.includes(value.name4)
                                                            && item.includes('-h')).slice(0, 3)" :key="index">
                                                            <el-col :span="8">
                                                                <el-avatar shape="square" :size="picSize" :fit="fit"
                                                                    :src="item"
                                                                    style="width: 100%;border-radius:0.3rem;border: 1px solid slategrey" />
                                                            </el-col>
                                                        </template>
                                                    </el-row>
                                                </el-col>
                                            </el-row>
                                        </el-card>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
import axios from 'axios'
import service from '../utils/request'
import { onMounted, ref } from 'vue'
import router from 'router'
import { useCache } from '../utils/usecache'

const title = '关系性介绍'
const subtitle = '想要了解谁呢？'

const picSize = ref(100)
const suffixes = ['.jpg', '.jpeg', '.png', '.gif']
const ga = ref()
const relation_list = ref()

const getRelation = () => {
    var api = '/user/relation/list'
    service.get(api).then(res => {
        relation_list.value = res.data
    })
        .catch(err => {
            console.log(err)
        })
}

const getData = async () => {
    try {
        const res = await useCache('galleryList', () => {
            return axios.get('/gallery/').then(res => res.data)
        })
        if (res && Array.isArray(res)) {
            ga.value = res.filter(item => {
                if (item.type !== 'file') return false;
                const suffix = item.name.slice(item.name.lastIndexOf('.')).toLowerCase();
                return suffixes.includes(suffix);
            }).map(item => { return 'http://img.helloworldend.top/gallery/' + item.name }).reverse()
        }
    } catch (error) {
        console.error('获取图片列表失败：', error)
    }
}

const getChara = async () => {
    try {
        const res = await useCache('charaListList', () => {
            return service.get("/user/chara/listList").then(res => res.data)
        })
        if (res.length && res[0] != null) {
            charaList.value = res
            allChara.value = res
        } else {
            console.error('返回角色信息为空')
        }
    } catch (error) {
        console.error('获取角色信息失败', error)
    }
}

const toDetail = (title) => {
    router.push('/relation/' + title)
}

const getWindowInfo = () => {
    const windowInfo = {
        width: window.innerWidth,
        height: window.innerHeight
    };
    setPicSize(windowInfo.width, windowInfo.height);
};


const setPicSize = (width, height) => {
    // var val = document.body.clientWidth
    const def = 800 // 默认宽度
    if (width < def) {
        picSize.value = 100
    } else {
        picSize.value = width / 6
    }
}
window.addEventListener('resize', getWindowInfo);

onMounted(() => {
    // getChara()
    getData()
    getRelation()
    getWindowInfo()
})
</script>
<style scoped>
.el-divider {
    margin-top: 2rem;
    margin-bottom: 1rem;
}
</style>